import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(date: string | Date): string {
  return new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })
}

export function formatDateTime(date: string | Date): string {
  return new Date(date).toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

export function getStatusColor(status: string): string {
  const colors: Record<string, string> = {
    completed: 'bg-green-500',
    'in_progress': 'bg-yellow-500',
    not_started: 'bg-gray-400',
    open: 'bg-yellow-500',
    closed: 'bg-green-500',
    urgent: 'bg-red-500',
    high: 'bg-orange-500',
    medium: 'bg-yellow-500',
    low: 'bg-blue-500'
  }
  return colors[status] || 'bg-gray-400'
}

export function getLevelColor(level: string): string {
  const colors: Record<string, string> = {
    Fundamentals: 'bg-blue-500',
    Essentials: 'bg-purple-500',
    Advanced: 'bg-orange-500'
  }
  return colors[level] || 'bg-gray-400'
}
